import React from "react";
import Menu from "../../Menu";
import Footer from "../../footer";
// import TextField, { Input } from '@material/react-text-field';
import * as Api from "../../api/main";
import { Redirect } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import * as UserActions from "../../actions/userDataActions";
import { set_loading } from "../../actions/loadingActions";
import {
  set_isValid,
  set_modal,
  set_redirectToValidateOrFinish,
  set_url_for_finish,
} from "../../actions/stepTwoActions";
import InputMask from "react-input-mask";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Checkbox from "@material-ui/core/Checkbox";
import ReactGA from "react-ga";
import cookie from "react-cookies";
import Spinner from "../../helpers/Spinner";
// import { hotjar } from 'react-hotjar';

class StepTwo extends React.Component {
  constructor(props) {
    super(props);
    this.buttonNext = this.buttonNext.bind(this);
    this.renderRedirect = this.renderRedirect.bind(this);
    this.passportVerify = this.passportVerify.bind(this);
    this.validateOffer = this.validateOffer.bind(this);
  }
  state = {
    isLoading: false,
  };

  componentDidMount() {
    ReactGA.pageview("/registration-step2-new2");
    //  hotjar.initialize(1592041,6);
    let { phone } = this.props.store.userDataReducer;

    if (!phone) {
      this.props.dispatch(set_url_for_finish("/registration-step1-new2"));
      this.props.dispatch(set_redirectToValidateOrFinish(true));
    }

    ValidatorForm.addValidationRule("PhoneChecker", (value) => {
      return this.props.store.userDataReducer.phone.length == 10;
    });

    ValidatorForm.addValidationRule("SeriesValidator", (value) => {
      //console.log(this.props.store.userDataReducer.doc_number);
      return !(
        value.replace(/[\s_\-()]+/g, "").length < 8 ||
        this.props.store.userDataReducer.doc_number.replace(/[\s_\-()]+/g, "").length < 8
      );
    });

    ValidatorForm.addValidationRule("RussianSymbolsChecker", (value) => {
      //console.log('RussianSymbolsChecker', value);
      return !(
        value.match(/\d+/) ||
        !value.match(/^[А-Яа-яа-щА-ЩЬьЮюЯяЇїІіЄєҐґ(\-)(\ )(\')]+$/) ||
        value.length < 0 ||
        false ||
        value.length <= 0
      );
    });

    ValidatorForm.addValidationRule("DateValidator", (value) => {
      let { birth_date } = this.props.store.userDataReducer;
      let days =
        birth_date.replace(/[\s\_\-\(\)]+/g, "").length >= 1 ? birth_date.substr(0, 2) : "0";
      let month = birth_date.length >= 3 ? birth_date.substr(2, 2) : "0";
      let year = birth_date.length >= 5 ? birth_date.substr(4, 4) : "0";
      return true;
    });

    ValidatorForm.addValidationRule("PassportеDateValidator", (value) => {
      let { doc_date } = this.props.store.userDataReducer;
      let days = doc_date.replace(/[\s\_\-\(\)]+/g, "").length >= 1 ? doc_date.substr(0, 2) : "0";
      let month = doc_date.length >= 3 ? doc_date.substr(2, 2) : "0";
      let year = doc_date.length >= 5 ? doc_date.substr(4, 4) : "0";

      return true;
    });

    ValidatorForm.addValidationRule("innvalidator", (value) => {
      if (this.props.store.userDataReducer.inn.length < 10 || !value.match(/[0-9]/)) {
        return false;
      }
      return true;
    });

    this.interval = setInterval(async () => {
      try {
        let {
          token,
          inn,
          last_name,
          fio,
          second_name,
          email,
          referer,
          doc_number,
          city,
          phone,
          birth_date,
          doc_date,
          amount,
          days,
        } = this.props.store.userDataReducer;
        const response = await Api.registerClientTemp(
          token,
          inn,
          last_name,
          fio,
          second_name,
          email,
          referer,
          doc_number,
          city,
          phone,
          birth_date,
          doc_date,
          amount,
          days,
        );
        //console.log("phonephone2", phone);
        if (response) {
          //console.log(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  passportVerify(value) {
    this.props.dispatch(UserActions.set_doc_number(value.replace(/[\s_\-()]+/g, "")));
  }

  validateOffer(checked) {
    ReactGA.event({
      category: "Reg-step2-offert",
      action: "регистрация-шаг2-оферта",
    });
    this.props.dispatch(set_isValid(checked));
  }

  async buttonNext() {
    let {
      token,
      inn,
      last_name,
      fio,
      second_name,
      email,
      referer,
      doc_number,
      city,
      phone,
      birth_date,
      doc_date,
      // final_code_url,
    } = this.props.store.userDataReducer;
    this.setState({ isLoading: true });

    const { date_amount, range_amount } = this.props.store.rangeSliderReduser;
    clearInterval(this.interval);
    console.log(this.props.store.userDataReducer);
    console.log(this.props.store.rangeSliderReduser);
    try {
      let response = await Api.registerNewClient(
        token,
        inn,
        last_name,
        fio,
        second_name,
        email,
        referer,
        doc_number,
        city,
        phone,
        birth_date,
        doc_date,
        date_amount,
        range_amount,
      );
      console.log("response", response);

      if (response.data.joint_id) {
        cookie.save("joint_id", response.data.joint_id, { path: "/" });
      }

      if (response) {
        this.props.dispatch(set_loading(false));
        //console.log(phone);
        //console.log(response.data);

        this.setState({ isLoading: false });
        const resCode = response.data.code;
        const code =
          resCode === 0 ||
          resCode === 1 ||
          resCode === 2 ||
          resCode === 3 ||
          resCode === 4 ||
          resCode === 5 ||
          resCode === 6 ||
          resCode === 8 ||
          resCode === 9
            ? resCode
            : 7;
        //console.log('code', code);

        this.props.dispatch(UserActions.set_code_final(code));

        // await Api.sendUserInfo(this.props.store.userDataReducer,this.props.store.rangeSliderReduser,code);

        if (code != 7) {
          ReactGA.event({
            category: "Reg-step2-next",
            action: "Рега шаг 2 далее",
          });
        }
        console.log("code", code);
        switch (code) {
          case 0:
            this.props.dispatch(set_url_for_finish("/final-0"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 1:
            this.props.dispatch(set_url_for_finish("/smsvalidation"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 2:
            this.props.dispatch(set_url_for_finish("/final-2"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 3:
            this.props.dispatch(set_url_for_finish("/smsvalidation"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 4:
            this.props.dispatch(set_url_for_finish("/smsvalidation"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 5:
            this.props.dispatch(set_url_for_finish("/final-5"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 6:
            this.props.dispatch(set_url_for_finish("/smsvalidation"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 8:
            this.props.dispatch(set_url_for_finish("/final-8"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          case 9:
            this.props.dispatch(set_url_for_finish("/final-9"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
          default:
            this.props.dispatch(set_url_for_finish("/final-7"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
            break;
        }

        // if (response.data.code == "1" || response.data.code == "4") {
        //     this.props.dispatch(set_url_for_finish('/smsvalidation'))
        //     this.props.dispatch(set_redirectToValidateOrFinish(true))
        // } else {
        //     if (final_code_url === '2') {
        //         this.props.dispatch(set_url_for_finish('/final-2'))
        //         this.props.dispatch(set_redirectToValidateOrFinish(true))
        //     } else if (final_code_url === '3') {
        //         this.props.dispatch(set_url_for_finish('/final-3'))
        //         this.props.dispatch(set_redirectToValidateOrFinish(true))
        //     } else if (final_code_url === '5') {
        //         this.props.dispatch(set_url_for_finish('/final-5'))
        //         this.props.dispatch(set_redirectToValidateOrFinish(true))
        //     }

        // }
      }
    } catch (error) {
      this.setState({ isLoading: false });
      //console.log(error);
    }
  }

  renderRedirect = () => {
    if (this.props.store.stepTwoReducer.redirectToValidateOrFinish) {
      return <Redirect to={{ pathname: this.props.store.stepTwoReducer.url }} />;
    }
  };

  render() {
    const normal = () => {
      //console.log('asdasd')
      if (document.getElementsByName("email")[0].getAttribute("aria-invalid") === "false") {
        document.getElementsByName("email")[0].classList.add("input_ok");
      } else {
        document.getElementsByName("email")[0].classList.remove("input_ok");
      }
    };
    return (
      <div>
        <Menu />
        <LoadingOverlay
          className="loading"
          text="Триває обробка даних"
          active={this.props.store.loadingReducer.loading}
          spinner={
            <div className="spiner">
              <ClipLoader className="spiner" color={"#fff"} />
            </div>
          }
        ></LoadingOverlay>

        {this.renderRedirect()}
        {normal}
        <div className="main-block-registration">
          <h1>Заповніть заявку на кредит</h1>
          <div className="form-block">
            <div className="registerinfo">Особисті дані</div>

            <ValidatorForm
              ref="form"
              onSubmit={(e) => this.buttonNext()}
              onError={(errors) =>
                window.scrollTo(10, document.getElementsByName(errors[0].props.name).offsetTop)
              }
              //
            >
              <div className="registerMainInfo">
                <TextValidator
                  value={this.props.store.userDataReducer.last_name}
                  label="Прізвище"
                  name={
                    this.props.store.userDataReducer.last_name != null &&
                    this.props.store.userDataReducer.last_name.length > 0
                      ? "good"
                      : null
                  }
                  id="last_name"
                  className="stepOneField"
                  variant="outlined"
                  onChange={(e) => this.props.dispatch(UserActions.set_last_name(e.target.value))}
                  validators={["required", "RussianSymbolsChecker"]}
                  errorMessages={[
                    "Вкажіть ваше прізвище україніською мовою",
                    "Вкажіть ваше прізвище україніською мовою",
                  ]}
                />
                <TextValidator
                  value={this.props.store.userDataReducer.fio}
                  label="Ім'я"
                  name={
                    this.props.store.userDataReducer.fio != null &&
                    this.props.store.userDataReducer.fio.length > 0
                      ? "good"
                      : null
                  }
                  variant="outlined"
                  id="fio"
                  className="stepOneField"
                  onChange={(e) => this.props.dispatch(UserActions.set_fio(e.target.value))}
                  validators={["required", "RussianSymbolsChecker"]}
                  errorMessages={[
                    "Вкажіть Ваше ім'я українською мовою",
                    "Вкажіть Ваше ім'я українською мовою",
                  ]}
                />
                <TextValidator
                  value={this.props.store.userDataReducer.second_name}
                  label="Прізвище"
                  name={
                    this.props.store.userDataReducer.second_name != null &&
                    this.props.store.userDataReducer.second_name.length > 0
                      ? "good"
                      : null
                  }
                  className="stepOneField"
                  id="second_name"
                  variant="outlined"
                  onChange={(e) => this.props.dispatch(UserActions.set_second_name(e.target.value))}
                  validators={["required", "RussianSymbolsChecker"]}
                  errorMessages={[
                    "Вкажіть ваше прізвище українською мовою",
                    "Вкажіть ваше прізвище українською мовою",
                  ]}
                />
                <div className="double-form-check">
                  <InputMask
                    mask="99.99.9999"
                    value={
                      this.props.store.userDataReducer.birth_date != null &&
                      this.props.store.userDataReducer.birth_date
                    }
                    onChange={(e) =>
                      this.props.dispatch(UserActions.set_birth_date(e.target.value))
                    }
                  >
                    {(inputProps) => (
                      <TextValidator
                        {...inputProps}
                        label="Дата народження*"
                        name={
                          this.props.store.stepTwoReducer.birth_date != null &&
                          this.props.store.userDataReducer.birth_date.length > 0
                            ? "good"
                            : null
                        }
                        id="birth_date"
                        className="stepOneField"
                        validators={["required", "DateValidator"]}
                        variant="outlined"
                        errorMessages={["Вкажіть вашу дату народження", "Вкажіть вашу дату народження"]}
                      />
                    )}
                  </InputMask>

                  <TextValidator
                    value={this.props.store.userDataReducer.city}
                    label="Місто проживання"
                    name={
                      this.props.store.userDataReducer.city != null &&
                      this.props.store.userDataReducer.city.length > 0
                        ? "good"
                        : null
                    }
                    className="stepOneField"
                    id="city"
                    variant="outlined"
                    onChange={(e) =>
                      this.props.store.userDataReducer.city.length <= 20
                        ? this.props.dispatch(UserActions.set_city(e.target.value))
                        : null
                    }
                    validators={["required", "RussianSymbolsChecker"]}
                    errorMessages={["Вкажіть місто проживання", "Вкажіть місто проживання"]}
                  />
                </div>
                <div className="double-form-check">
                  <InputMask
                    mask="**99999999"
                    formatChars={{
                      9: "[0-9]",
                      a: "[A-Za-z]",
                      "*": "[А-Яа-яA-Za-z0-9]",
                    }}
                    value={this.props.store.userDataReducer.doc_number}
                    onChange={(e) => this.passportVerify(e.target.value)}
                  >
                    {(inputProps) => (
                      <TextValidator
                        {...inputProps}
                        label="Серія та номер паспорту*"
                        className="stepOneField"
                        name={
                          this.props.store.userDataReducer.doc_number != null &&
                          this.props.store.userDataReducer.doc_number.length > 0
                            ? "good"
                            : null
                        }
                        id="doc_number"
                        validators={["required", "SeriesValidator"]}
                        variant="outlined"
                        errorMessages={[
                          "Вкажіть серію та номер паспорту",
                          "Вкажіть серію та номер паспорту",
                        ]}
                      />
                    )}
                  </InputMask>

                  {/* /[IVXLCDM]{4,7}[\s]*-[\s]*[A-Я]{2}[\s]*[0-9]{6}/ */}

                  <InputMask
                    mask="99.99.9999"
                    value={this.props.store.userDataReducer.doc_date}
                    onChange={(e) => this.props.dispatch(UserActions.set_doc_date(e.target.value))}
                  >
                    {(inputProps) => (
                      <TextValidator
                        {...inputProps}
                        label="Дата видачі паспорту*"
                        name={
                          this.props.store.userDataReducer.doc_date != null &&
                          this.props.store.userDataReducer.doc_date.length > 0
                            ? "good"
                            : null
                        }
                        className="stepOneField"
                        variant="outlined"
                        id="doc_date"
                        validators={["required", "PassportеDateValidator"]}
                        errorMessages={[
                          "Вкажіть вірно Вашу дату видачі паспорту. Наприклад - 02.07.1988",
                          "Вкажіть вірно Вашу дату видачі паспорту. Наприклад - 02.07.1988",
                        ]}
                      />
                    )}
                  </InputMask>
                </div>

                <TextValidator
                  value={this.props.store.userDataReducer.inn}
                  onChange={(e) =>
                    this.props.dispatch(
                      UserActions.set_inn(e.target.value.substr(0, 10).replace(/[^0-9]/g, "")),
                    )
                  }
                  label="ІПН*"
                  className="stepOneField"
                  name={
                    this.props.store.userDataReducer.inn != null &&
                    this.props.store.userDataReducer.inn.length > 0
                      ? "good"
                      : null
                  }
                  variant="outlined"
                  id="inn"
                  validators={["required", "innvalidator"]}
                  errorMessages={["Вкажіть Ваш ІПН", "Вкажіть Ваш ІПН"]}
                />
              </div>

              <hr></hr>
              <div className="registerinfo">Контактні дані</div>
              <div className="registerDopInfo">
                {/* <TextValidator
                  value={this.props.store.userDataReducer.email}
                  onChange={(e) => this.props.dispatch(UserActions.set_email(e.target.value))}
                  label="E-mail*"
                  className="stepOneField"
                  name={
                    this.props.store.userDataReducer.email != null &&
                    this.props.store.userDataReducer.email.length > 0
                      ? "good"
                      : null
                  }
                  variant="outlined"
                  id="email"
                  validators={["required", "isEmail"]}
                  errorMessages={[
                    "Укажите правильно Ваш email. Например: pertov@gmail.com",
                    "Укажите правильно Ваш email. Например: pertov@gmail.com",
                  ]}
                /> */}

                <TextValidator
                  disabled
                  value={this.props.store.userDataReducer.phone}
                  label="Телефон"
                  variant="outlined"
                  name="phone"
                  id="phone"
                  className="stepOneField"
                  validators={["required", "PhoneChecker"]}
                  errorMessages={[
                    "Вкажіть правильно номер телефону. Наприклад - +38 (093) 123-45-67",
                    "Вкажіть правильно номер телефону. Наприклад - +38 (093) 123-45-67",
                  ]}
                />
              </div>
              <div className="accept-block">
                <Checkbox
                  className="CheckboxMain"
                  checked={
                    this.props.store.stepTwoReducer.isValid != null &&
                    this.props.store.stepTwoReducer.isValid
                  }
                  onChange={(e) => this.validateOffer(e.target.checked)}
                  value="checkedA"
                  inputProps={{
                    "aria-label": "primary checkbox",
                  }}
                />
                <p className="modalDialog">
                  Я приймаю{" "}
                  <span className="modalLink" onClick={(e) => this.props.dispatch(set_modal(true))}>
                    умови надання послуг
                  </span>
                  {this.props.store.stepTwoReducer.isValid ? null : (
                    <span
                      onClick={(e) => this.props.dispatch(set_isValid(true))}
                      className="info-error-icon"
                    />
                  )}
                  {this.props.store.stepTwoReducer.isValid ? null : (
                    <p style={{ color: "red" }}>
                      {" "}Ви повинні ознайомитись з Умовами надання послуг{" "}
                    </p>
                  )}
                </p>

                <Button type="submit" className="MuiButtonMew" type="submit" id="secondStepNext">
                  Далі
                </Button>
              </div>
            </ValidatorForm>
          </div>
        </div>

        <Modal
          className="modal"
          open={this.props.store.stepTwoReducer.modal}
          onClose={(e) => this.props.dispatch(set_modal(false))}
        >
          <div className="modalText">
            <div class="terms-block">
              <span class="clothe_modal" onClick={(e) => this.props.dispatch(set_modal(false))} />
              <h2>Умови надання послуг</h2>
              <p>
                Справжнім я передаю Фінансової Компанії, що використовує домен
                
                <a href={"https://sgroshi.com/"} target={"_blank"}>
                  sgroshi.com
                </a>
                свою згоду і право на:
              </p>
              <p>
                - обробку моїх персональних даних, зазначених мною в запиті про надання кредиту, включаючи: відомості про П.І.Б .; дані що підтверджують особу;
              </p>
              <p>
                - передавати, збирати, зберігати, використовувати, отримувати, розповсюджувати, обробляти будь-яку інформацію про мене в /від/через
                <br />
                ТОВ "Українське бюро кредитних історій, яке знаходиться за адресою:{" "}
                <a
                  href="https://www.google.com/maps?q=%D0%BC.%D0%9A%D0%B8%D1%97%D0%B2,+%D0%93%D1%80%D1%83%D1%88%D0%B5%D0%B2%D1%81%D1%8C%D0%BA%D0%BE%D0%B3%D0%BE+1-%D0%B4&amp;entry=gmail&amp;source=g"
                  target={"_blank"}
                >
                  01001, м.Київ, вул. Грушевського, буд. 1-д
                </a>
                .<br />
                ПАТ «Перше всеукраїнське бюро кредитних історій», яке знаходиться за адресою:{" "}
                <a
                  href="https://www.google.com/maps?q=02002,+%D0%BC.+%D0%9A%D0%B8%D1%97%D0%B2,+%D0%B2%D1%83%D0%BB.+%D0%9C%D0%B0%D1%80%D0%B8%D0%BD%D0%B8+%D0%A0%D0%B0%D1%81%D0%BA%D0%BE%D0%B2%D0%BE%D1%97,+%D0%B1%D1%83%D0%B4.+11&amp;entry=gmail&amp;source=g"
                  target="_blank"
                >
                  02002, м. Київ, вул. Марини Раскової, буд. 11
                </a>
                ;<br />
                ПАТ «Міжнародне бюро кредитних історій», яке знаходиться за адресою:{" "}
                <a
                  href="https://www.google.com/maps?q=%D0%9F%D0%B5%D1%80%D0%B5%D0%BC%D0%BE%D0%B3%D0%B8,+%D0%B1%D1%83%D0%B4.+65&amp;entry=gmail&amp;source=g"
                  target="_blank"
                >
                  03062, м. Київ, просп. Перемоги, буд. 65, офіс 306
                </a>
                ;<br />
                ТОВ «Незалежне бюро кредитних історій», яке знаходиться за адресою:{" "}
                <a
                  href="https://www.google.com/maps?q=%D0%BC.+%D0%9A%D0%B8%D1%97%D0%B2,+%D0%B2%D1%83%D0%BB.+%D0%92%D0%BE%D0%BB%D0%BE%D0%B4%D0%B8%D0%BC%D0%B8%D1%80%D1%81%D1%8C%D0%BA%D0%B0,+%D0%B1%D1%83%D0%B4.+78&amp;entry=gmail&amp;source=g"
                  target="_blank"
                >
                  01033, м. Київ, вул. Володимирська, буд. 78, офіс 1
                </a>
                .
              </p>
              <p>Компанія ШвидкоГроші</p>
              <p>
                ШвидкоГроші – це спеціалізована фінансова компанія «Споживчий Центр».
                <br />
                Ми зареєстровані Національною комісією, що здійснює державне регулювання у сфері ринків фінансових послуг, свідоцтво про реєстрацію фінансової установи ІК №78.
              </p>
              <p>Єдиний вид діяльності компанії – видача кредитів.</p>
              <p>
                Наші реквізити:
                <br />
                ТОВ «СПОЖИВЧИЙ ЦЕНТР», ЄДРПОУ 37356833,{" "}
                <a
                  href="https://www.google.com/maps?q=%D0%9A%D0%B8%D1%97%D0%B2,+%D0%B2%D1%83%D0%BB.+%D0%A1%D0%B0%D0%BA%D1%81%D0%B0%D0%B3%D0%B0%D0%BD%D1%81%D1%8C%D0%BA%D0%BE%D0%B3%D0%BE,+133-%D0%90&amp;entry=gmail&amp;source=g"
                  target="_blank"
                >
                  01032, Київ, вул. Саксаганського, 133-А
                </a>
                , тел. (044) 498 10 20, <a href="mailto:info@sgroshi.com">info@sgroshi.com</a>
                <br />У відповідності з Законом України про Захист Прав Споживачів клієнт може ознайомитися з повним комплектом документів у відділеннях ШвидкоГроші.
              </p>
            </div>
          </div>
        </Modal>
        <Spinner isLoading={this.state.isLoading} />
        <Footer />
      </div>
    );
  }
}

export default connect((state) => ({ store: state }))(StepTwo);



// WEBPACK FOOTER //
// src/pages/registration/stepTwo.js